import clsx from 'clsx';
import React, { memo } from 'react';
import { useReframe } from 'nike-re-framejs';

import TicketIcon from '@/icons/TicketIcon';
import { normalizeSportEventId } from '@/nikeone/domain/sportevent';
import { activeTicketsCount } from '@/mytickets/active/subs';

function TicketStatus({ sportEventId }) {
    const { subscribe } = useReframe();
    const count = subscribe(activeTicketsCount(normalizeSportEventId(sportEventId)));
    return count ? (
        <div className="pull-left">
            <div className={clsx('ticketus-icon', { 'ticketus-icon-simple': count === 1 })}>
                <TicketIcon width={10} height={10} fill={'#ffffff'} />
                {count > 1 ? <small>{count}</small> : null}
            </div>
        </div>
    ) : null;
}

export default memo(TicketStatus);
